<template>
    <div class="row justify-space-between mb-3">
        <DxCheckBox v-model="ThongTinKhaiBaoVe.InVe" text="In vé" />
        <div
            class="text-link font-medium"
            @click="MoTrang('/Bao-Cao/Ve-Doanh-Nghiep-Tu-Khai-Bao')"
        >
            Danh sách vé tự khai báo
        </div>
    </div>
    <DxValidationGroup ref="formValidation">
        <div class="row mb-4">
            <div class="xs12">
                <DxTextBox
                    label="Biển kiểm soát (*)"
                    v-model="ThongTinKhaiBaoVe.BienKiemSoat"
                    styling-mode="underlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="20"
                            message="Không được vượt quá 20 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mb-4">
            <div class="xs12">
                <DxDateBox
                    label="Giờ xuất bến (*)"
                    labelMode="floating"
                    v-model="ThongTinKhaiBaoVe.GioXuatBen"
                    displayFormat="HH:mm:ss dd/MM/yyyy"
                    type="datetime"
                    dropDownButtonTemplate="customIcon"
                    validationMessageMode="always"
                    :useMaskBehavior="true"
                    styling-mode="underlined"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được để trống!" />
                        <DxRangeRule
                            :max="MaxDate"
                            :message="$i18n.t('DefaultString.MaxDate')"
                        />
                        <DxRangeRule
                            :min="MinDate"
                            :message="$i18n.t('DefaultString.MinDate')"
                        />
                    </DxValidator>
                    <template #customIcon="{}">
                        <DxButton icon="mdi mdi-calendar" />
                    </template>
                </DxDateBox>
            </div>
        </div>
        <div class="row mb-4">
            <div class="xs12">
                <DxTextBox
                    label="Bến đến (*)"
                    v-model="ThongTinKhaiBaoVe.BenDen"
                    styling-mode="underlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="128"
                            message="Không được vượt quá 128 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mb-4">
            <div class="xs12">
                <DxTextBox
                    label="Mã tuyến"
                    v-model="ThongTinKhaiBaoVe.MaTuyen"
                    styling-mode="underlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <!-- <DxRequiredRule message="Không được bỏ trống!" /> -->
                        <DxStringLengthRule
                            :max="20"
                            message="Không được vượt quá 20 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row">
            <div class="xs12">
                <DxNumberBox
                    label="Số lượng vé (*)"
                    v-model="ThongTinKhaiBaoVe.SoLuongVe"
                    styling-mode="underlined"
                    validationMessageMode="always"
                    labelMode="floating"
                    :showSpinButtons="true"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxRangeRule :min="1" message="Không được nhỏ hơn 1!" />
                        <DxRangeRule
                            :max="10"
                            message="Không được vượt quá 10!"
                        />
                    </DxValidator>
                </DxNumberBox>
            </div>
        </div>
    </DxValidationGroup>

    <div
        class="row mt-3"
        style="
            position: fixed;
            bottom: 0;
            left: 0;
            background-color: #fff;
            border-top: 1px solid #ccc;
            padding: 8px 16px;
            width: 100%;
        "
    >
        <div class="xs12">
            <DxButton
                type="default"
                styling-mode="contained"
                text="KHAI BAO VÉ"
                width="100%"
                @click="KhaiBaoVe"
            />
        </div>
    </div>

    <DxPopup
        v-if="ifPopupXacNhanKhaiBaoVe"
        v-model:visible="PopupXacNhanKhaiBaoVe"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        :width="424"
        height="auto"
        @hidden="onHidden('PopupXacNhanKhaiBaoVe')"
    >
        <DxScrollView ref="DxScrollViewThongBao" width="100%" height="100%">
            <PopupXacNhanVue
                :Params="ParamsXacNhanKhaiBaoVe"
                @click="XacNhanKhaiBaoVe"
            />
        </DxScrollView>
    </DxPopup>
</template>
<script>
import {
    DxCheckBox,
    DxTextBox,
    DxNumberBox,
    DxValidator,
    DxDateBox,
    DxButton,
    DxValidationGroup,
    DxPopup,
    DxScrollView,
} from "devextreme-vue";
import {
    DxRangeRule,
    DxRequiredRule,
    DxStringLengthRule,
} from "devextreme-vue/data-grid";
import PopupXacNhanVue from "@sonphat/common-v1/components/PopupXacNhan";

export default {
    components: {
        DxCheckBox,
        DxValidationGroup,
        DxDateBox,
        DxButton,
        DxTextBox,
        DxNumberBox,
        DxValidator,
        DxRangeRule,
        DxRequiredRule,
        DxStringLengthRule,
        DxPopup,
        DxScrollView,
        PopupXacNhanVue,
    },
    props: {},
    data() {
        return {
            MaxDate: this.$Helper.Common.getEndDay(
                new Date(this.$i18n.t("DefaultNumBer.MaxDate"))
            ),
            MinDate: this.$Helper.Common.getStartDay(
                new Date(this.$i18n.t("DefaultNumBer.MinDate"))
            ),
            ifPopupXacNhanKhaiBaoVe: false,
            PopupXacNhanKhaiBaoVe: false,
            ParamsXacNhanKhaiBaoVe: {
                WidthTitle: "95%",
                Title: "Bạn chắc chắn thông tin khai báo vé đã chính xác?",
                btnLeft: "HỦY",
                btnRight: "XÁC NHẬN",
            },
        };
    },
    computed: {
        ThongTinKhaiBaoVe: {
            get() {
                return this.$store.state.KhaiBaoVe.ThongTinKhaiBaoVe;
            },
            set(data) {
                this.$store.commit("KhaiBaoVe/Set", {
                    key: "ThongTinKhaiBaoVe",
                    data,
                });
            },
        },
    },
    methods: {
        MoTrang(link) {
            this.$router.push(link);
        },
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        hiddenPopup(name) {
            this[name] = false;
        },
        KhaiBaoVe() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.showPopup("PopupXacNhanKhaiBaoVe");
        },
        XacNhanKhaiBaoVe(bool) {
            if (bool == false) {
                this.hiddenPopup("PopupXacNhanKhaiBaoVe");
            } else if (bool == true) {
                this.hiddenPopup("PopupXacNhanKhaiBaoVe");
                this.ThucHienKhaiBaoVe();
            }
        },
        async ThucHienKhaiBaoVe() {
            try {
                this.$startLoading;
                let rs = await this.$store.dispatch(
                    "KhaiBaoVe/ThucHienKhaiBaoVe"
                );
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Khai báo vé thành công!"
                    );
                    if (this.ThongTinKhaiBaoVe.InVe) {
                        return await this.$Events.Print(
                            SP[`Base_Url`],
                            this.$t("urlKhaiBaoVe.LayPhieuInVe"),
                            {
                                DanhSachVe: (rs.data || []).map(
                                    (e) => e.IdVeTiepNhan
                                ),
                            }
                        );
                    }
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Khai báo vé thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Khai báo vé thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
    created() {},
    mounted() {},
    beforeUnmount() {
        this.$store.commit("KhaiBaoVe/Reset_ThongTinKhaiBaoVe");
    },
};
</script>
<style scoped></style>
